export default __webpack_public_path__ + "static/Agrigento_Sicily_Italy-05bf9aae4c021dee9db803e227116b48.jpg";